module.exports = __webpack_public_path__ + "static/media/logo.ebdeb750.svg";